import { render, staticRenderFns } from "./copyNoAssiginNode.vue?vue&type=template&id=1a60ea6e&"
import script from "./copyNoAssiginNode.vue?vue&type=script&lang=js&"
export * from "./copyNoAssiginNode.vue?vue&type=script&lang=js&"
import style0 from "./copyNoAssiginNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports